import { GetterTree } from 'vuex';

import { FoldersStateI } from './state';
import { RootStateI } from '../state';

export const getters: GetterTree<FoldersStateI, RootStateI> = {
};
